 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTTITLE_PAGE from '@/components/Text/title_page'
 import LOVE_1 from '@/components/love_1'
 import TEXT004TITLE from '@/components/Text/004title'
 import TEXT005COPYRIGHT from '@/components/Text/005copyright'
 import TEXT006SYNOPSIS from '@/components/Text/006synopsis'
 import TEXT007CHARACTER from '@/components/Text/007character'
 import TEXT011PART5 from '@/components/Text/011part5'
 import TEXT012CHAP16 from '@/components/Text/012chap16'
 import TEXT013CHAP17 from '@/components/Text/013chap17'
 import TEXT014CHAP18 from '@/components/Text/014chap18'
 import TEXT015PART6 from '@/components/Text/015part6'
 import TEXT016CHAP19 from '@/components/Text/016chap19'
 import TEXT017CHAP20 from '@/components/Text/017chap20'
 import TEXT018CHRONLOGY from '@/components/Text/018chronlogy'
 import TEXT019CONCORD from '@/components/Text/019concord'
 import TEXT020HOUSES from '@/components/Text/020houses'
 import TEXT021STANDARD from '@/components/Text/021standard'
 import LOVE_2 from '@/components/love_2'
 import TEXT022GLOSSARY1 from '@/components/Text/022glossary1'
 import TEXT023GLOSSARY2 from '@/components/Text/023glossary2'
 import TEXTCHAP159684 from '@/components/Text/chap159684'
 import TEXTCHAP149530 from '@/components/Text/chap149530'
 import TEXTCREDITS from '@/components/Text/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/title_page",
 			"name" : "Text/title_page",
 			"component" : TEXTTITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/004title",
 			"name" : "Text/004title",
 			"component" : TEXT004TITLE
 		},
 		{
 			"path" : "/Text/005copyright",
 			"name" : "Text/005copyright",
 			"component" : TEXT005COPYRIGHT
 		},
 		{
 			"path" : "/Text/006synopsis",
 			"name" : "Text/006synopsis",
 			"component" : TEXT006SYNOPSIS
 		},
 		{
 			"path" : "/Text/007character",
 			"name" : "Text/007character",
 			"component" : TEXT007CHARACTER
 		},
 		{
 			"path" : "/Text/011part5",
 			"name" : "Text/011part5",
 			"component" : TEXT011PART5
 		},
 		{
 			"path" : "/Text/012chap16",
 			"name" : "Text/012chap16",
 			"component" : TEXT012CHAP16
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js